import { render, staticRenderFns } from "./RevisitDeviceDetailsCard.vue?vue&type=template&id=02273c58&"
import script from "./RevisitDeviceDetailsCard.vue?vue&type=script&lang=js&"
export * from "./RevisitDeviceDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports